module.exports = __webpack_public_path__ + "img/09.b256c86d.jpg";